import { z } from "zod";
import { auditActorFields } from "../common/audit.js";
import { pagedResponse, paginationQuerySchema } from "../common/pagination.js";
import { booleanQueryParam } from "../common/query-params.js";
export const zoneInfo = z.object({
    id: z.string().uuid(),
    storeId: z.string().uuid(),
    storeName: z.string(),
    storeCode: z.string(),
    storeMapId: z.string().uuid().nullable(),
    categoryId: z.string().uuid().nullable(),
    categoryName: z.string().nullable(),
    code: z.string(),
    name: z.string(),
    mapCoordinates: z.record(z.unknown()),
    sortOrder: z.number().int().nullable(),
    isActive: z.boolean(),
    metadata: z.record(z.unknown()),
    createdAt: z.string().datetime(),
    updatedAt: z.string().datetime(),
    ...auditActorFields,
});
export const createZoneRequest = z.object({
    storeId: z.string().uuid(),
    storeMapId: z.string().uuid().nullish(),
    categoryId: z.string().uuid().nullish(),
    code: z.string().min(1).max(100),
    name: z.string().min(1).max(255),
    mapCoordinates: z.record(z.unknown()).default({}),
    sortOrder: z.number().int().nullish(),
    isActive: z.boolean().default(true),
    metadata: z.record(z.unknown()).default({}),
});
export const updateZoneRequest = createZoneRequest.partial().refine((v) => Object.keys(v).length > 0, { message: "At least one field required" });
export const listZonesQuery = paginationQuerySchema.extend({
    storeId: z.string().uuid().optional(),
    storeMapId: z.string().uuid().optional(),
    categoryId: z.string().uuid().optional(),
    isActive: booleanQueryParam.optional(),
});
export const zonesListResponse = pagedResponse(zoneInfo);
export const archiveZoneResponse = z.object({ ok: z.literal(true) });
//# sourceMappingURL=zones.schemas.js.map